import { useEffect, useState } from 'react';
import { generateVehicleReadyQRCode } from '../../API/GoMoto';
import { ImageHelper } from '../ImageHelper/ImageHelper';
import { Spinner } from '../Spinner/Spinner';
import css from './VehicleReadyQRCode.module.scss';
import { VehicleReadyQRCodeProps } from './VehicleReadyQRCode.types';
import { useLocalization } from '../../context/Localization/localization';

/**
 * Generates the QR code to be used for retriving a vehicle and displays it.
 */
export const VehicleReadyQRCode = ({ appointmentKey }: VehicleReadyQRCodeProps) => {
    const [qrCode, setQRCode] = useState<string>('');
    const Localization = useLocalization();

    useEffect(() => {
        if (!qrCode) {
            const generateQRCode: Promise<string> = generateVehicleReadyQRCode(appointmentKey);

            generateQRCode.then((qrCode) => {
                setQRCode(qrCode);
            });
        }
    }, [appointmentKey, qrCode]);

    return !qrCode ? (
        <Spinner />
    ) : (
        <div className={css.vehicleReadyQRCodeWrapper}>
            <div className={css.qrCode}>
                <ImageHelper imageProps={{ src: qrCode,
                    alt: Localization.QRCodeIcon }}
                />
            </div>
        </div>
    );
};
